// extracted by mini-css-extract-plugin
export default {"box":"content-module__box___f86fac","scrollable":"content-module__scrollable___1b19c1","mobile":"content-module__mobile___f02322"};